import React, { useCallback, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import Table from 'antd/lib/table'

import apiManager from 'helpers/apiManager'
import useQuery from 'hooks/useQuery'
import { dateFormatter } from 'helpers'
import { ROUTES } from 'helpers/constants'
import { ChevronLeftIcon, PrimaryButton } from 'components'
import CreateClientModal from './CreateClientModal'

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 60,
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Profile',
    dataIndex: 'profile',
    key: 'profile',
    width: 400,
    render: text => (
      <div className="text-sm text-gray-600 max-h-24 overflow-y-auto whitespace-pre-wrap">
        {text || '-'}
      </div>
    ),
  },
  {
    title: 'Summary',
    dataIndex: 'summary',
    key: 'summary',
    width: 400,
    render: text => (
      <div className="text-sm text-gray-600 max-h-24 overflow-y-auto whitespace-pre-wrap">
        {text || '-'}
      </div>
    ),
  },
  {
    title: 'Created At',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: text => (text ? dateFormatter.returnYYYYMMDD(text) : '-'),
  },
  {
    title: 'Updated At',
    dataIndex: 'updatedAt',
    key: 'updatedAt',
    render: text => (text ? dateFormatter.returnYYYYMMDD(text) : '-'),
  },
]

const AdminAISearchClients = () => {
  const [showModal, setShowModal] = useState(false)
  const [isCreating, setIsCreating] = useState(false)

  const { data, isLoading } = useQuery('admin/search/clients', () =>
    apiManager.adminGetSearchClients()
  )

  const clients = useMemo(
    () =>
      data?.map(client => ({
        ...client,
        key: client.id,
      })) || [],
    [data]
  )

  const handleOpenModal = useCallback(() => {
    setShowModal(true)
  }, [])

  const handleCloseModal = useCallback(() => {
    setShowModal(false)
  }, [])

  const handleCreateClient = useCallback(async payload => {
    setIsCreating(true)
    try {
      await apiManager.adminCreateSearchClient(payload)
      window.location.reload()
    } catch (error) {
      console.error('Failed to create client:', error)
      setIsCreating(false)
    }
  }, [])

  return (
    <div className="w-full min-h-screen px-4 bg-white py-4 md:px-10">
      <div className="flex items-center justify-between mb-4">
        <Link
          to={ROUTES.ADMIN_AI_SEARCH}
          className="inline-flex items-center text-blue-500 hover:text-blue-700"
        >
          <ChevronLeftIcon className="w-5 h-5 mr-1" />
          Back to AI Search
        </Link>
        <PrimaryButton onClick={handleOpenModal}>Create Client</PrimaryButton>
      </div>
      <h1 className="text-4xl text-center mb-8">Search Clients</h1>
      <div>
        <Table
          columns={columns}
          dataSource={clients}
          loading={isLoading}
          pagination={{
            defaultPageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
          }}
        />
      </div>
      <CreateClientModal
        show={showModal}
        onClose={handleCloseModal}
        onSave={handleCreateClient}
        isLoading={isCreating}
      />
    </div>
  )
}

export default AdminAISearchClients
